// Lista dos campos do seu form — mantém em sincronia com o schema
const FORM_FIELDS = [
  'modality',
  'company_name',
  'issqn',
  'address_updated',
  'legal_representative',
  'legal_representative_email',
  'aplicant_name',
  'email',
  'phone',
  'employee_number',
  'card_quantity',
  'company_document',
  'inscricao',
  'categoria',
  'rede_social',
  'otherinput',
  // arquivos
  'cpffile',
  'inscricaofile',
  'contratofile',
  'esocialfile',
  'managementagreement',
  'address_proof',
];

export function extractFieldErrors(apiData: any): Record<string, string> {
  if (!apiData || typeof apiData !== 'object') return {};

  const errors: Record<string, string> = {};

  FORM_FIELDS.forEach(field => {
    const value = apiData[field];
    if (!value) return;

    // A API pode retornar string ou array (["msg1", "msg2"])
    if (Array.isArray(value) && value.length > 0) {
      errors[field] = String(value[0]);
    } else if (typeof value === 'string') {
      errors[field] = value;
    }
  });

  return errors;
}
